import { render, staticRenderFns } from "./ZyroModal.vue?vue&type=template&id=13e52036&scoped=true&"
import script from "./ZyroModal.vue?vue&type=script&lang=js&"
export * from "./ZyroModal.vue?vue&type=script&lang=js&"
import style0 from "./ZyroModal.vue?vue&type=style&index=0&id=13e52036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e52036",
  null
  
)

export default component.exports